export class UpdatePersonRequest {
    action: string
    person: Person
}

export class Person {
    catPersonType: number
    language: string
    firstName: string
    middleName: string
    lastName: string
    email: string
    ssn: string
    id: number
}

interface IBuilder {
    buildCatPersonType(catPersonType: number): this
    buildLanguage(language: string): this
    buildFirstName(firstName: string): this
    buildMiddleName(middleName: string): this
    buildLastName(lastName: string): this
    buildEmail(email: string): this
    buildSsn(ssn: string): this
    buildId(id: number): this
    buildAction(action: string): this
    getResult(): UpdatePersonRequest
}

export class UpdatePersonBuilder implements IBuilder {
    person: Person
    updatePersonRequest: UpdatePersonRequest

    constructor() {
        this.person = new Person()
        this.updatePersonRequest = new UpdatePersonRequest()
    }

    buildAction(action: string): this {
        this.updatePersonRequest.action = action
        return this
    }

    buildCatPersonType(catPersonType: number): this {
        this.person.catPersonType = catPersonType
        return this
    }
    buildLanguage(language: string): this {
        this.person.language = language
        return this
    }
    buildFirstName(firstName: string): this {
        this.person.firstName = firstName
        return this
    }
    buildMiddleName(middleName: string): this {
        this.person.middleName = middleName
        return this
    }
    buildLastName(lastName: string): this {
        this.person.lastName = lastName
        return this
    }
    buildEmail(email: string): this {
        this.person.email = email
        return this
    }
    buildSsn(ssn: string): this {
        this.person.ssn = ssn
        return this
    }
    buildId(id: number): this {
        this.person.id = id
        return this
    }

    getResult() {
        this.updatePersonRequest.person = this.person
        return this.updatePersonRequest
    }
}
